import React from "react";
import fetch from "cross-fetch";
import PropTypes from "prop-types";
import Contact from "./Contact";
import { BarLoader } from "react-spinners";

class Geolocator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countryName: "",
            stateCode: "",
            stateName: "",
            hasChanged: false
        };

        this.updateState = this.updateState.bind(this);
    }

    componentDidMount() {
        // Call API with Key
        const url =
            "https://api.ipstack.com/check?access_key=fa3338c153af27b092496717eeeafa53&format=1";
        // Check if we already called the API, if not - fetch
        !this.state.hasChanged
            ? fetch(url)
                  .then(response => response.json())
                  .then(data => {
                      this.setState({
                          countryName: data.country_name,
                          stateCode: data.region_code,
                          stateName: data.region_name
                      });
                  })
                  // Resolve a promise to prop the found state
                  .then(() => {
                      //const opt = document.querySelector(`option[value="${this.state.stateCode}"]`),
                      // select = document.querySelector(`.contact__select`);
                      // opt.setAttribute('selected', 'selected');
                      this.setState({
                          stateCode: this.state.stateCode
                      });
                  })
                  .catch(error => {
                      console.log(error);
                  })
            : ``;
    }

    updateState(event) {
        // Grab Contact select's value, update states
        const val = event.target.value;
        this.setState({
            stateCode: val,
            hasChanged: true
        });

        // GTM Event
        window.dataLayer.push({
            event: "location",
            state: val
        });
    }

    render() {
        const { contacts } = this.props;
        const { stateCode, stateName } = this.state || {};
        const ln = contacts.length;

        return (
            <section className="contact">
                <div className="wrapper">
                    <p className="contact__intro">
                        For further information, please contact your regional
                        marketing manager.
                    </p>
                    <section className="contact__location">
                        <h3 className="contact__current">Current Location:</h3>
                        <div className="select-wrapper contact__select-wrap">
                            <select
                                name="contact__select"
                                id="contact__select"
                                className="contact__select select-styled"
                                onChange={this.updateState}
                                value={stateCode}
                            >
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="DC">District Of Columbia</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">New York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dakota</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dakota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
                            </select>
                        </div>
                    </section>
                    {ln > 0 ? (
                        contacts
                            .map((contact, i) => (
                                <Contact
                                    contact={contact}
                                    code={stateCode}
                                    state={stateName}
                                    key={i}
                                />
                            ))
                            .filter(contact =>
                                contact.props.contact.states.includes(
                                    contact.props.code
                                )
                            )
                    ) : (
                        <div className="spinner-holder">
                            <BarLoader color={"#150F96"} />
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

export default Geolocator;



// WEBPACK FOOTER //
// ./src/components/Geolocator.js